// =============================================
// Simulation Banner — מוצג בכל ה-layouts כשסימולציה פעילה
// Kipikid — מערכת נוכחות ילדים בגנים
// =============================================
// שינויים עיקריים:
// - משתמש ב-raw fetch (לא api.get) כדי לעבוד בלי token
// - לא ניתן לסגירה — תמיד מוצג בזמן סימולציה
// - שומר מצב ב-simulationStore הגלובלי
// - מתקן באג timezone (חילוץ שעה ישירות ללא new Date)

import { useEffect, useState } from 'react';
import { Activity } from 'lucide-react';
import { useSimulationStore, startSimulationPolling, stopSimulationPolling } from '../stores/simulationStore';

export default function SimulationBanner() {
  const { active, ratio, getDisplayTime } = useSimulationStore();
  const [, setTick] = useState(0);

  // Start polling on mount, stop on unmount
  useEffect(() => {
    startSimulationPolling();
    return () => stopSimulationPolling();
  }, []);

  // Force re-render every second for smooth clock display
  useEffect(() => {
    if (!active) return;
    const t = setInterval(() => setTick(v => v + 1), 1000);
    return () => clearInterval(t);
  }, [active]);

  if (!active) return null;

  // Use interpolated display time for smooth clock
  const displayTime = getDisplayTime();
  const hh = String(displayTime.getHours()).padStart(2, '0');
  const mm = String(displayTime.getMinutes()).padStart(2, '0');
  const ss = String(displayTime.getSeconds()).padStart(2, '0');
  const timeStr = `${hh}:${mm}:${ss}`;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      height: '36px',
      backgroundColor: '#dc2626',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px',
      fontSize: '13px',
      fontWeight: '600',
      zIndex: 9999,
      boxShadow: '0 2px 8px rgba(220,38,38,0.3)',
      direction: 'ltr',
    }}>
      <div style={{
        width: '8px', height: '8px', borderRadius: '50%',
        backgroundColor: 'white', animation: 'simPulse 1s infinite',
      }} />
      <Activity size={14} />
      <span>מצב סימולציה</span>
      <span style={{ fontFamily: 'monospace', fontSize: '15px', letterSpacing: '1px' }}>
        {timeStr}
      </span>
      <span style={{ opacity: 0.7 }}>×{ratio}</span>

      <style>{`
        @keyframes simPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }
      `}</style>
    </div>
  );
}
